/* RYSE . HEADER - busca e paineis do menu (out/2026)
   1) Paineis .rmg: o destaque da direita acompanha o item sob o mouse
      (foto, sobretitulo, nome, linha, avaliacao, parcela e link). Abrir e
      fechar e com o ryse-header-core.js.
   2) Busca:
   - Desktop: a lupa da pilula abre o painel #rbus embaixo da aba.
   - Celular: o campo no topo do menu.
   Os dois sao <form data-rbus> e usam a busca preditiva da Shopify
   (/search/suggest.json). Enter vai para a pagina de busca normal. */
(function () {
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function brl(v) { var n = Number(v); return isNaN(n) ? '' : 'R$ ' + n.toFixed(2).replace('.', ','); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function liga(form) {
    var input = form.querySelector('input[name="q"]');
    var caixa = form.querySelector('[data-rbus-r]');
    if (!input || !caixa) return;
    var t, pedido = 0;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { caixa.innerHTML = ''; return; }
      t = setTimeout(function () {
        var n = ++pedido;
        fetch(raiz + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (n !== pedido) return;
            var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
            var tudo = raiz + 'search?type=product&q=' + encodeURIComponent(q);
            if (!ps.length) {
              caixa.innerHTML = '<p class="rbus__vz">Nada encontrado para “' + esc(q) + '”.</p>';
              return;
            }
            caixa.innerHTML = ps.map(function (p) {
              var img = p.image || (p.featured_image && p.featured_image.url) || '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
              return '<a class="rbus__it" href="' + esc(p.url) + '">' +
                '<span class="rbus__im"' + (img ? ' style="background-image:url(' + esc(img) + ')"' : '') + '></span>' +
                '<span class="rbus__tx"><b>' + esc(p.title) + '</b><small>' + brl(p.price) + '</small></span></a>';
            }).join('') + '<a class="rbus__all" href="' + tudo + '">Ver todos os resultados</a>';
          })
          .catch(function () { if (n === pedido) caixa.innerHTML = ''; });
      }, 180);
    });
  }
  document.querySelectorAll('form[data-rbus]').forEach(liga);

  /* painel do desktop */
  var btn = document.querySelector('[data-rbus-abre]');
  var painel = document.getElementById('rbus');
  if (!btn || !painel) return;
  function abre() {
    painel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    document.dispatchEvent(new CustomEvent('ryse:fecha-carrinho'));
    var i = painel.querySelector('input[name="q"]'); if (i) setTimeout(function () { i.focus(); }, 30);
  }
  function fecha() { painel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
  btn.addEventListener('click', function (e) { e.stopPropagation(); painel.hidden ? abre() : fecha(); });
  document.addEventListener('click', function (e) { if (!painel.hidden && !painel.contains(e.target) && !btn.contains(e.target)) fecha(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !painel.hidden) { fecha(); btn.focus(); } });
})();

/* paineis do desktop: o destaque segue o item sob o mouse */
(function () {
  document.querySelectorAll('[data-rmg]').forEach(function (m) {
    var ft = m.querySelector('[data-rmg-ft]');
    if (!ft) return;
    var itens = [].slice.call(m.querySelectorAll('.rmg__row, .rmg__kit'));
    var campo = function (k) { return ft.querySelector('[data-f="' + k + '"]'); };
    var poe = function (k, v) { var e = campo(k); if (e) e.textContent = v || ''; };
    var ativa = function (it) {
      itens.forEach(function (x) { x.classList.toggle('on', x === it); });
      var d = it.dataset, img = campo('img');
      if (img && d.img) img.style.backgroundImage = 'url(' + d.img + ')';
      poe('ey', d.ey); poe('nm', d.nm); poe('nm2', d.nm); poe('ln', d.ln); poe('ds', d.ds);
      poe('p1', d.p1); poe('p2', d.p2);
      var rv = campo('rv');
      if (rv) { var t = rv.querySelector('span:last-child'); if (t) t.textContent = d.rv || ''; rv.hidden = !d.rv; }
      var u = campo('url'); if (u) u.href = it.getAttribute('href');
    };
    var inicial = ft.dataset.on ? m.querySelector('[data-i="' + ft.dataset.on + '"]') : null;
    if (inicial) inicial.classList.add('on');
    itens.forEach(function (it) {
      it.addEventListener('mouseenter', function () { ativa(it); });
      it.addEventListener('focus', function () { ativa(it); });
    });
  });
})();
